/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_CHECK_SUMMARY, CHECK_SUMMARY_RECEIVED } = constants.checkSummaryConstants;

export default {
    REQUEST_CHECK_SUMMARY,
    CHECK_SUMMARY_RECEIVED,

  requestCheckSummary: payload => ({
    type: REQUEST_CHECK_SUMMARY,
    payload
  }),
  checkSummaryReceived: () => ({
    type: CHECK_SUMMARY_RECEIVED
  }),
};
